import { FC } from 'react';

import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";
import { Medium } from "@/constants/mediums";

const WaterReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.water} />;
};

export default WaterReadingsDetailPage;
